import { render, staticRenderFns } from "./extension_period.vue?vue&type=template&id=28555bc8&"
import script from "./extension_period.vue?vue&type=script&lang=js&"
export * from "./extension_period.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports